import React, { Component } from "react";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import ErrorText from "../error-success/ErrorText";

class ErrorDialog extends Component {
	shouldComponentUpdate(props) {
		if (this.props.show !== props.show) {
			return true;
		}

		return false;
	}

	render() {
		let buttons = [
			{
				type: Button,
				text: "OK",
				action: () => {
					this.props.handleClose();
				}
			}
		];

		return this.props.show ? (
			<Modal title={"Error"} buttons={buttons}>
				<ErrorText classes={`no-margin`} errors={this.props.errors} />
			</Modal>
		) : null;
	}
}

export default ErrorDialog;



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/ErrorDialog.js